import React, { useState, useEffect } from "react";
import { getAccessTokenApi ,getRefreshTokenApi,getPublicIP} from "../../../api/auth";
import { getUsersActiveApi, Keyrock } from "../../../api/user";
import ListUsers from "../../../components/Admin/Users/ListUsers";
import { BrowserRouter as Router, Link, Route, Routes } from "react-router-dom";
import { message, Upload, Button,Checkbox,Divider ,notification,TreeSelect  ,Col, InputNumber, Row, Slider, Space ,Switch} from "antd";
import { CloudDownloadOutlined } from "@ant-design/icons";
import { basePath, apiVersion } from "../../../api/config";
import Logo from "../../../assets/img/png/logo-white.png";
import {getContarError} from "../../../api/user";
import {get} from "../../../api/get";

import "./Instructions.scss";

export default function Historia() {
  const [usersActive, setUsersActive] = useState([]); //Todos los usuarios
  const [usersInactive, setUsersInactive] = useState([]);
  const [reloadUsers, setReloadUsers] = useState(false);

  const token = getAccessTokenApi();

  useEffect(() => {
    get(`users-active?active=${true}`,'users-active','').then((response) => {
      // getUsersActiveApi(token, true).then((response) => {
        //console.log(response);
        setUsersActive(response.users);
      });
    get(`users-active?active=${false}`,'users-active','').then((response) => {
    // getUsersActiveApi(token, false).then((response) => {
      setUsersInactive(response.users);
    });

    setReloadUsers(false);
  }, [token, reloadUsers]); //Solo se refresca si cambian estos

  return (
    <>
    <div className="instructions">
    <div className="instructions-up">
            <a href="/" className="instructions-up-pictureAndLogo-logo">
              <img src={Logo} alt="logo" />
            </a>
        </div>
      </div>
      <div className="marg">
        <h2>Who are we?: </h2>
        <h1 >Crafting a Sustainable Future: Capillar IT</h1>
        <div style={{marginBottom:'12px',fontFamily:'report',fontSize:'20px'}}>In 2022, from the heart of Zaragoza, a pioneering endeavor known as Capillar IT emerged. This chronicle is a tapestry woven with threads of innovation and environmental consciousness, a saga that reverberates through time.</div>
        <h1 >Origins and Purpose</h1>
        <div style={{marginBottom:'12px',fontFamily:'report',fontSize:'20px'}}>Nestled within the historic city of Zaragoza, Capillar IT was born. Our inception coincided with a resounding purpose – to revolutionize last-mile logistics. Envisioning a world where commerce and sustainability coexist, our journey began with an unwavering commitment to forge a new path.</div>
        <h1 >Environmental Harmony</h1>
        <div style={{marginBottom:'12px',fontFamily:'report',fontSize:'20px'}}>In a world marred by environmental concerns, Capillar IT stood as a beacon of change. Our mission was clear – to redefine last-mile logistics by embracing eco-friendly resources. Amidst the bustling streets, the hum of electric vehicles and the swish of bicycles replaced carbon-emitting alternatives, weaving a harmonious narrative between progress and planet.</div>
        <h1 >Global Collaborations</h1>
        <div style={{marginBottom:'12px',fontFamily:'report',fontSize:'20px'}}>Our tale traverses geographical boundaries, finding resonance in Europe's ambitious projects and Mexico's vibrant landscapes. Collaborations became cornerstones, laying the foundation for a revolutionary software. This software, a digital maestro, optimizes human and logistical resources, serving as the pivot around which a company's operational rhythm flows.</div>
        <h1 >Efficiency and Sustainability Unite</h1>
        <div style={{marginBottom:'12px',fontFamily:'report',fontSize:'20px'}}>At Capillar IT's core lies a symphony, harmonizing efficiency with sustainability. The software emerged as the crescendo, orchestrating intricate operational notes. It transformed mundane tasks into strategic decisions, envisioning a landscape where sustainability and success entwine seamlessly.</div>
        <h1 >A Journey without End</h1>
        <div style={{marginBottom:'12px',fontFamily:'report',fontSize:'20px'}}>Capillar IT's narrative is one of perpetuity. An unending quest to redefine norms, challenge conventions, and craft a future where innovation walks hand-in-hand with the environment. It's an ongoing odyssey to nurture a world where commerce thrives, leaving behind a legacy of ecological responsibility.</div>
        <h1 >A Call to Co-Create Tomorrow</h1>
        <div style={{fontFamily:'report',fontSize:'20px'}}>The Capillar IT story is an invitation extended to all dreamers, innovators, and guardians of our planet. A testament to the notion that progress need not come at the expense of nature. It's a narrative of collective vision, where sustainable choices steer the wheels of commerce towards a brighter horizon.</div>
        <div style={{fontFamily:'report',fontSize:'20px'}}>Each thread woven into Capillar IT's narrative is a testament to our dedication to innovation, environmental stewardship, and the conviction that a sustainable future is not just a possibility, but an imperative.</div>

      </div>
    </>
  );
}
